import { render, staticRenderFns } from "./WithdrawalReview.vue?vue&type=template&id=79c222fb&scoped=true&"
import script from "./WithdrawalReview.vue?vue&type=script&lang=js&"
export * from "./WithdrawalReview.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalReview.vue?vue&type=style&index=0&id=79c222fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c222fb",
  null
  
)

export default component.exports